/**
 * Perform device-releated actions (get list of devices, getUserMedia, etc.)
 * @module Device
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Cookies from "js-cookie";
import { getFrameRate } from "./frame_rate";
import createLog from "./log";
var log = createLog("device");
export function getInputDevices() {
    return __awaiter(this, void 0, void 0, function () {
        var devices, requestPermissionsNeeded, audioDevicesPresent, videoDevicesPresent, stream, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, navigator.mediaDevices.enumerateDevices()];
                case 1:
                    devices = _a.sent();
                    requestPermissionsNeeded = devices.some(function (device) { return device.deviceId === '' || device.label === ''; });
                    if (!requestPermissionsNeeded) return [3 /*break*/, 7];
                    audioDevicesPresent = devices.some(function (device) { return device.kind === 'audioinput'; });
                    videoDevicesPresent = devices.some(function (device) { return device.kind === 'videoinput'; });
                    stream = void 0;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ audio: audioDevicesPresent, video: videoDevicesPresent })];
                case 3:
                    stream = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (error_1.name != "NotAllowedError") {
                        log("Can not list input devices. GetUserMedia error: ", error_1.name);
                    }
                    throw error_1;
                case 5: return [4 /*yield*/, navigator.mediaDevices.enumerateDevices()];
                case 6:
                    devices = _a.sent();
                    stream.getTracks().forEach(function (track) {
                        track.stop();
                    });
                    _a.label = 7;
                case 7: 
                // Only return: 1) input devices, 2) devices with compatible kind (audio or video), 3) devices with valid id and label
                return [2 /*return*/, devices.filter(function (_a) {
                        var kind = _a.kind, deviceId = _a.deviceId, label = _a.label;
                        return /input/.test(kind) && deviceId !== "" && label !== "";
                    })];
            }
        });
    });
}
export function filterDevicesByKind(devicesType, devices) {
    return devices.filter(function (_a) {
        var kind = _a.kind;
        return new RegExp(devicesType).test(kind);
    });
}
export function getAudioTrackForDevice(audioDevice, audioProcessingDisabled) {
    return __awaiter(this, void 0, void 0, function () {
        var audioDeviceId, audioConstraints, audioStream;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    audioDeviceId = audioDevice.deviceId;
                    if (!audioDeviceId) {
                        return [2 /*return*/, null];
                    }
                    audioConstraints = {
                        audio: {
                            deviceId: audioDeviceId ? { exact: audioDeviceId } : undefined,
                            autoGainControl: { ideal: false },
                            echoCancellation: { ideal: !audioProcessingDisabled },
                            noiseSuppression: { ideal: !audioProcessingDisabled }
                        },
                        video: false
                    };
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia(audioConstraints)];
                case 1:
                    audioStream = _a.sent();
                    if (!audioStream) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, audioStream.getAudioTracks()[0]];
            }
        });
    });
}
export function getVideoTrackForDevice(videoDevice) {
    return __awaiter(this, void 0, void 0, function () {
        var videoDeviceId, frameRateValue, frameRateConstraint, constrains, videoStream;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    videoDeviceId = videoDevice.deviceId;
                    if (!videoDeviceId) {
                        return [2 /*return*/, null];
                    }
                    frameRateValue = getFrameRate();
                    frameRateConstraint = frameRateValue ? { frameRate: { max: frameRateValue } } : {};
                    if (frameRateValue) {
                        log("Will use " + frameRateValue + " FPS");
                    }
                    constrains = {
                        video: __assign({ deviceId: videoDeviceId ? { exact: videoDeviceId } : undefined, width: { max: 1280, ideal: 1280, min: 1280 / 4 }, height: { max: 720, ideal: 720, min: 720 / 4 } }, frameRateConstraint),
                        audio: false,
                    };
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia(constrains)];
                case 1:
                    videoStream = _a.sent();
                    if (!videoStream) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, videoStream.getVideoTracks()[0]];
            }
        });
    });
}
export function getPreferredDevices() {
    return {
        videoDeviceId: Cookies.get("net.telestream.webrtc.selectedVideoDeviceId"),
        audioDeviceId: Cookies.get("net.telestream.webrtc.selectedAudioDeviceId"),
    };
}
export function setPreferredDevices(_a) {
    var video = _a.video, audio = _a.audio;
    if (video) {
        Cookies.set("net.telestream.webrtc.selectedVideoDeviceId", video);
    }
    if (audio) {
        Cookies.set("net.telestream.webrtc.selectedAudioDeviceId", audio);
    }
}
/**
 * Find device by device ID among other devices
 * @param {string} deviceToFindId - id of the device to find
 */
export function findDeviceById(deviceToFindId, allDevices) {
    return allDevices.find(function (device) { return device.deviceId === deviceToFindId; });
}
export function getDefaultFromList(preferredDeviceId, deviceList, store) {
    if (!deviceList || deviceList.length === 0)
        return undefined;
    var foundDevice = findDeviceById(preferredDeviceId, deviceList);
    if (foundDevice) {
        return foundDevice.deviceId;
    }
    return deviceList[0].deviceId;
}



//////////////////
// WEBPACK FOOTER
// ./src/device.ts
// module id = 67
// module chunks = 1